<template>
  <!-- 执业律师 -->
  <div class="practicing_lawyer text_center">
    <sec-title
      ac-text="执业"
      Text="律师"
      desc-text="接受委托或者指定，为当事人提供法律服务的执业人员"
    />

    <div class="between zhiye">
	<div  v-for="(item, index) in list"
		  :key="index">
		<lay-item-win2
		  class="item"
		 :item = 'item'
		></lay-item-win2>
	</div>
    </div>
  </div>
</template>

<script>
import secTitle from "../components/secTitle";
import layItemWin2 from "../components/layItemWin2";
export default {
  components: {
    layItemWin2,
    secTitle,
	
  },
  data(){
	  return{
		  list:[]
	  }
  },
  created() {
  	this.$http.home.lawyerads({
		ad_id:12,
		limit:4
	}).then( res => {
		this.list = res.data.data
	})
  }
};
</script>

<style lang="scss" scoped>
.practicing_lawyer {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 50px;
  .item {
    width: 274px;
    height: 360px;
  }
}
</style>